function validateInput(scenario, startYear) {

  // 验证输入是否符合规范
  if (!scenario || startYear === "") {
    return {
      isValid: false,
      errorMessage: "Please fill out all fields."
    };
  } /*else if (parseInt(startYear) > parseInt(endYear)) {
    return {
      isValid: false,
      errorMessage: "Start year cannot be greater than end year."
    };
  } */ else {
    // 向服务器发送数据或执行其他操作
    console.log("Scenario: " + scenario);
    console.log("Start Year: " + startYear);
    // console.log("End Year: " + endYear);
    // 返回验证后的参数
    return {
      isValid: true,
      scenario: scenario,
      startYear: startYear
      // endYear: endYear
    };
  }
}

function showError(message) {
    var errorElement = document.getElementById("error");
    errorElement.textContent = message;
}

export { validateInput, showError };